var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    fill: "white",
    stroke: "#949394"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4678 12.3828H14.9062V18.9362",
    stroke: "black",
    strokeWidth: 1.52405,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.125 19.0879H17.383",
    stroke: "black",
    strokeWidth: 1.52405,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7539 10.0967C14.5128 10.0967 14.277 10.0252 14.0765 9.8912C13.876 9.75723 13.7198 9.56681 13.6275 9.34402C13.5352 9.12124 13.5111 8.87609 13.5581 8.63958C13.6051 8.40307 13.7213 8.18582 13.8918 8.01531C14.0623 7.8448 14.2795 7.72868 14.516 7.68163C14.7526 7.63459 14.9977 7.65873 15.2205 7.75101C15.4433 7.84329 15.6337 7.99957 15.7677 8.20007C15.9016 8.40057 15.9731 8.6363 15.9731 8.87744C15.9731 9.2008 15.8447 9.51092 15.616 9.73957C15.3874 9.96823 15.0773 10.0967 14.7539 10.0967Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.91a71ac92f1c6baeb8e7d47807258728.svg";
export { ForwardRef as ReactComponent };